import { Icon } from "@fluentui/react";
import ErrorTooltip from "@cayo/shared/components/common/ErrorTooltip";
import { hasOwnKey } from "@cayo/shared/utils/typeUtils";
import { lookupIcon, propertyIcon } from "./common";
import { RenderCellFn } from "./types";
import { getFormatterFromRenderOptions } from "../../../utils/formatter-utils";
import formatterControls from "../../Schemes/renderers/formatter.renderers";
import RenderOptionsFormatter from "../utils/field-formatter";

//const log = logger.getLogger("RENDER-CELL icon-only");

export const renderIconOnlyCell: RenderCellFn = ({ item, column, auxProps }) => {
  // TODO: temp workaround until #33544 is done
  if (column.fieldName === "ObjIcon" && item?.ObjIcon) {
    return (
      <Icon
        iconName={item.ObjIcon}
        styles={{ root: { fontSize: 18 } }}
        title={item.ObjIconLabel}
        aria-label={item.ObjIconLabel}
      />
    );
  }

  const fieldFormatter = new RenderOptionsFormatter(
    column.renderOptions,
    getFormatterFromRenderOptions
  );

  if (!(column.isIconOnly || fieldFormatter.isIconOnly())) {
    return null;
  }

  const isNone =
    item[column.fieldName!] === "none" && column.fieldName !== "lastVerificationStatus";
  if (isNone) {
    return <></>;
  }
  const formatter = column.renderOptions?.formatter;
  const formatterName = formatter?.toLowerCase();

  if (hasOwnKey(formatterControls, formatterName)) {
    const FormatterControl = formatterControls[formatterName];

    return <FormatterControl {...item} />;
  }

  const icon = lookupIcon(item, auxProps!, column.fieldName);
  //log.debug("lookupIcon -> ", column.fieldName, icon);
  if (!icon || !icon?.isIconOnly) {
    return null;
  }

  let iconComponent = propertyIcon(icon, item[column.fieldName!]);
  if (item?.errors?.length > 0) {
    iconComponent = (
      <ErrorTooltip id={item.id} errors={item.errors}>
        {iconComponent}
      </ErrorTooltip>
    );
  }
  return iconComponent;
};
